import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@es-tools/shared';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="logo-section" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
          <div className="es-logo">
            <span className="logo-es">ES</span>
            <span className="logo-text">AUTOMATION</span>
          </div>
          <span className="tagline">Easy Street Brands</span>
        </div>
        <nav className="header-nav">
          <button 
            className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </button>
          <button 
            className={`nav-link ${isActive('/automation-library') ? 'active' : ''}`}
            onClick={() => navigate('/automation-library')}
          >
            Automation Library
          </button>
          <button
            className={`nav-link ${isActive('/data-platform') ? 'active' : ''}`}
            onClick={() => navigate('/data-platform')}
          >
            Data Platform
          </button>
          <button 
            className={`nav-link ${isActive('/holy-shipped') ? 'active' : ''}`}
            onClick={() => navigate('/holy-shipped')}
          >
            🚢 Holy Shipped
          </button>
        </nav>
        <div className="header-actions">
          <div className="user-dropdown" ref={dropdownRef}>
            <button 
              className="user-dropdown-trigger" 
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {user?.picture ? (
                <img src={user.picture} alt={user.name} className="user-avatar" />
              ) : (
                <div className="user-avatar-placeholder">
                  {user?.name?.charAt(0).toUpperCase()}
                </div>
              )}
              <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12">
                <path d="M3 5L6 8L9 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
              </svg>
            </button>
            
            {dropdownOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <span className="dropdown-user-name">{user?.name}</span>
                  <span className="dropdown-user-email">{user?.email}</span>
                </div>
                <div className="dropdown-divider"></div>
                <button onClick={handleLogout} className="dropdown-item dropdown-signout">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H6M11 11L14 8M14 8L11 5M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
